// src/components/FeatureCard.js
import React from "react";

const FeatureCard = ({ feature }) => {
  return (
    <div
      style={{
        backgroundColor: "#faf8f5",
        borderRadius: "1rem",
        padding: "2rem 1.5rem",
        textAlign: "center",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        boxShadow: "0 4px 12px rgba(139, 69, 19, 0.06)",
      }}
    >
      <div
        style={{
          width: "80px",
          height: "80px",
          margin: "0 auto 1.25rem",
          backgroundColor: "#fff",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "2.5rem",
          boxShadow: "0 4px 10px rgba(139, 69, 19, 0.1)",
        }}
      >
        {feature.icon}
      </div>
      <h3
        style={{
          marginBottom: "0.75rem",
          fontSize: "1.25rem",
          fontWeight: "600",
          color: "#8b4513",
        }}
      >
        {feature.title}
      </h3>
      <p
        style={{
          fontSize: "0.95rem",
          color: "#7a6650",
          lineHeight: "1.6",
          margin: 0,
        }}
      >
        {feature.text}
      </p>
    </div>
  );
};

export default FeatureCard;

// // src/components/FeatureCard.js
// import React from "react";

// const FeatureCard = ({ feature }) => {
//   return (
//     <div style={{ textAlign: "center", padding: "1rem" }}>
//       <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>
//         {feature.icon}
//       </div>
//       <h3 style={{ marginBottom: "0.5rem", fontSize: "1.25rem" }}>
//         {feature.title}
//       </h3>
//       <p>{feature.text}</p>
//     </div>
//   );
// };

// export default FeatureCard;
